<template>
  <div id="ag-grid-demo">
    <vx-card>
      <div class="mb-4 mr-4 md:mb-0 ag-grid-table-actions-left">
          <h4 style="margin-left: 10px">RDRI</h4>
          <div style="float: right">
          <vs-button @click="exportExcel" class="mr-2">Export In Out</vs-button>
          <vs-button @click="exportInventory">Export Inventory</vs-button>
        </div>
      </div>
      <div style="float: right" class="mb-4 mr-4 md:mb-0 ag-grid-table-actions-right">

      </div>
    <div style="margin-top: 40px" class="vx-row">
      <div class="w-1/3 vx-col">
      <div class="mb-6 vx-row">
              <div class="w-full vx-col sm:w-1/3">
                  <span>Client ID</span>
              </div>
              <div class="w-full vx-col sm:w-2/3">
                <vs-select
                    class="selectExample"
                    v-model="form.client_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, client)"
                >
                    <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                </vs-select>
              </div>
          </div>

          <div class="mb-6 vx-row">
              <div class="w-full vx-col sm:w-1/3">
                  <span>Warehouse ID</span>
              </div>
              <div class="w-full vx-col sm:w-2/3">
                <vs-select
                    class="selectExample"
                    v-model="form.warehouse_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, warehouse)"
                >
                    <vs-select-item v-for="(item, index) in warehouse.data" :key="index" :value="item.id" :text="item.warehouses_code"/>
                </vs-select>
              </div>
          </div>
                  <div class="mb-6 vx-row">
              <div class="w-full vx-col sm:w-1/3">
                  <span>Posting Date</span>
              </div>
              <div class="w-full vx-col sm:w-1/3">
                  <flat-pickr class="w-full" v-model="form.start" />
              </div>
              <div class="w-full vx-col sm:w-1/3">
                  <flat-pickr class="w-full" v-model="form.end"/>
              </div>
                  </div>
        <div class="mb-6 vx-row">
              <div class="w-full vx-col sm:w-1/3">
                  <span>Product ID</span>
              </div>
              <div class="w-full vx-col sm:w-2/3">
                <vs-select
                    class="selectExample"
                    v-model="form.product_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, product)"
                >
                    <vs-select-item v-for="(item, index) in product.data" :key="index" :value="item.id" :text="item.product_code"/>
                </vs-select>
              </div>
          </div>
      </div>
    </div>

    </vx-card>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import { saveAs } from "file-saver";
import vSelect from "vue-select";
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
export default {
  components: {
    vSelect,
    AgGridVue,
    flatPickr,
  },
   data() {
    return {
      gridOptions: {},
      gridApi: null,
      data: [],
      columnDefs: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true
      },
      isLoading: false,
      form: {
        warehouse_id: null,
        product_id: null,
        client_id: 2,
        picked: 1,
      },
      warehouse: {
        data: [],
        loading: false,
        endpoint: 'master/warehouses',
        objectKey: 'warehouses_code'
      },
      product: {
        data: [],
        loading: false,
        endpoint: 'master/product',
        objectKey: 'product_code'
      },
      stock_type: {
        data: [],
        loading: false,
        endpoint: 'master/locationtypes',
        objectKey: 'code'
      },
      client: {
        data: [],
        loading: false,
        endpoint: 'master/clients',
        objectKey: 'client_code'
      },
      totalPage: 0,
      currentPage: 1,
      dataFrom: 0,
      dataTo: 0,
      dataTotal: 0
    };
  },
  watch: {
    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    },
    currentPage: function() {
      this.fetchData();
    }
  },
  methods: {
    refreshData() {
      this.currentPage == 1 ? this.fetchData() : (this.currentPage = 1);
    },
    fetchData() {
      this.isLoading = true;
      Promise.all([
      this.$http.post("master/warehouses"),
      this.$http.post("master/product"),
      this.$http.post("master/stocktypes"),
      this.$http.post("master/clients"),
      ])
        .then(
          this.$http.spread((warehouse, product, stocktypes, client) => {
            this.warehouse.data = warehouse.data.data;
            this.product.data = product.data.data;
            this.stock_type.data = stocktypes.data.data;
            this.client.data = client.data.data;
          })
        )
        .catch(() => {
          this.$vs.dialog({
            type: "confirm",
            color: "danger",
            title: "Error",
            text: "Try again?",
            accept: () => {
              this.refreshData();
            },
            acceptText: "Yes",
            cancelText: "No"
          });
        })
        .then(() => (this.isLoading = false));
    },
    exportExcel() {
      this.fetchData();
      this.isLoading = true;
      this.$http
        .post("report/rdri/", this.form, {
          responseType: "blob"
        })
        .then(response => {
          var blob = new Blob([response.data], {
            type: "application/pdf"
          });
          this.isLoading = false;
          saveAs(blob, "RDRI.xlsx");
        });
    },
    exportInventory() {
      this.isLoading = true;
      this.$http
        .post("report/rdriinv/", this.form, {
          responseType: "blob"
        })
        .then(response => {
          var blob = new Blob([response.data], {
            type: "application/pdf"
          });
          this.isLoading = false;
          saveAs(blob, "RDRI_Inventory.xlsx");
        })
        .catch(error => {
          this.isLoading = false;
          var reader = new FileReader()
          const globalThis = this
          reader.onload = function() {
            const object = JSON.parse(reader.result)
            const message = object.message ? object.message : 'Something went wrong.'
            globalThis.$vs.notify({
              color: 'danger',
              title: 'Error',
              iconPack: 'feather',
              icon: 'icon-x',
              text: message
            })
          }
          reader.readAsText(error.response.data)
        });
    },
  },
  mounted() {
    this.fetchData();
    this.gridApi = this.gridOptions.api;
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "Warehouse Code",
        field: "warehouses_code",
        width: 150,
      }
    ];
  }
};
</script>
